"use client";

import { useState } from "react";
import { storyblokEditable } from "@storyblok/react/rsc";
import { ArrowRight } from "@/components/icons/ArrowRight";

import {
  Button as ButtonComponent,
  type ButtonVariant,
  type ButtonSize,
} from "@/components/ui/button";
import { MembershipPaymentModal } from "@/components/membership/MembershipPaymentModal";
import type { ButtonStoryblok } from "@/component-types-sb";

const variantMap: Record<string, ButtonVariant> = {
  primary: "black",
  secondary: "white",
  sun: "sun",
  black: "black",
  white: "white",
  "mylife-green": "mylife",
  dexcom: "dexcom",
  minimed: "minimed",
};

const sizeMap: Record<string, ButtonSize> = {
  sm: "sm",
  lg: "lg",
  default: "sm",
};

const MembershipPaymentButton = ({ blok }: { blok: ButtonStoryblok }) => {
  const [open, setOpen] = useState(false);
  const mappedVariant: ButtonVariant = variantMap[blok.variant || ""] ?? "black";
  const mappedSize: ButtonSize = sizeMap[blok.size || ""] ?? "sm";

  return (
    <>
      <div
        onClick={() => setOpen(true)}
        role="button"
        tabIndex={0}
        onKeyDown={(e) => { if (e.key === "Enter" || e.key === " ") setOpen(true); }}
        className="cursor-pointer"
        data-cta-location="content_button"
        data-cta-label={blok.label}
        {...storyblokEditable(blok)}
      >
        <ButtonComponent variant={mappedVariant} size={mappedSize}>
          {blok.arrow === "left" && (
            <ArrowRight size={mappedSize === "lg" ? "lg" : "sm"} />
          )}
          {blok.label}
          {blok.arrow === "right" && (
            <ArrowRight size={mappedSize === "lg" ? "lg" : "sm"} />
          )}
        </ButtonComponent>
      </div>
      <MembershipPaymentModal
        open={open}
        onOpenChange={setOpen}
        source="button"
      />
    </>
  );
};

export default MembershipPaymentButton;
